import {
  EXPERIENCES_SEARCHED_REVIEWS,
  ExperiencesShopReviewsResponse,
  ITrackingProperties,
  ViewedExperienceDetailsProperties,
} from "redmond";
import { put, select } from "redux-saga/effects";
import { actions } from "../actions";
import Logger from "../../../utils/logger";
import { fetchExperiencesShopReviews } from "../../../api/v0/shop/fetchExperiencesShopReviews";
import { trackEvent } from "../../../api/v0/analytics/trackEvent";
import { getViewedExperienceDetailsProperties } from "../reducer";

export function* fetchExperiencesShopReviewsSaga(
  action: actions.IFetchExperiencesShopReviews
) {
  try {
    const reviewsResponse: ExperiencesShopReviewsResponse =
      yield fetchExperiencesShopReviews(action.request);
    yield put(actions.setExperiencesShopReviews(reviewsResponse));

    const viewedDetailsProperties: ITrackingProperties<ViewedExperienceDetailsProperties> =
      yield select(getViewedExperienceDetailsProperties);
    const { properties, encryptedProperties } = viewedDetailsProperties;

    trackEvent({
      eventName: EXPERIENCES_SEARCHED_REVIEWS,
      properties: {
        search_term: action.request.refinement.query ?? "",
        ...properties,
      },
      encryptedProperties: [...(encryptedProperties ?? "")],
    });
  } catch (e) {
    yield put(actions.setExperiencesShopReviewsCallStateFailed());
    Logger.debug(e);
  }
}
